import type { LegalOnboardingDocument } from "./merge-society-documents";
import type { DocDecision } from "../components/doc-list/types";

const hasDownloadableFile = (doc: LegalOnboardingDocument) =>
  Boolean(doc.urlDescarga) && doc.urlDescarga !== "-";

const isOptionalDocument = (doc: LegalOnboardingDocument) =>
  doc.tipo === "Opcional" ||
  (typeof doc.obligatorio === "boolean" ? !doc.obligatorio : false);

export interface DocumentDecisionSummary {
  decidableDocuments: LegalOnboardingDocument[];
  allAccepted: boolean;
  hasRejected: boolean;
  hasUndecided: boolean;
}

/**
 * A partir de los documentos de la solicitud y las decisiones tomadas en
 * pantalla, calcula qué documentos entran en la revisión final (excluye
 * opcionales sin archivo cargado) y si ya están todos aceptados, si hay
 * algún rechazo, o si queda alguno sin decidir.
 */
export const getDocumentDecisionSummary = (
  documentos: LegalOnboardingDocument[] | undefined,
  decisions: Record<number, DocDecision>,
): DocumentDecisionSummary => {
  const decidableDocuments = (documentos ?? []).filter(
    (doc) => !isOptionalDocument(doc) || hasDownloadableFile(doc),
  );

  const allAccepted =
    decidableDocuments.length > 0 &&
    decidableDocuments.every((doc) => decisions?.[doc.id] === "accept");

  const hasRejected = decidableDocuments.some(
    (doc) => decisions?.[doc.id] === "reject",
  );

  const hasUndecided = decidableDocuments.some(
    (doc) => (decisions?.[doc.id] ?? null) === null,
  );

  return { decidableDocuments, allAccepted, hasRejected, hasUndecided };
};
